import { Link } from "@tanstack/react-router"
import { LucideIcon, ArrowRight, Router, Globe, Bot, Shield, Workflow, Webhook, Lock, Database, Puzzle, BrainCircuit, BarChart3, Key, Zap, Eye, Network, AlertTriangle, CheckCircle, DollarSign, Clock, Users, FileCheck, FileText, Building2, Server, Settings, Code, MapPin, Mail, Phone, MessageSquare, MousePointer, GitBranch, TrendingDown, TrendingUp, Brain, GraduationCap, Heart, Laptop, Rocket } from "lucide-react"

const iconMap: Record<string, LucideIcon> = {
  Router,
  Globe,
  Bot,
  Shield,
  Workflow,
  Webhook,
  Lock,
  Database,
  Puzzle,
  BrainCircuit,
  BarChart3,
  Key,
  Zap,
  Eye,
  Network,
  AlertTriangle,
  CheckCircle,
  DollarSign,
  Clock,
  Users,
  FileCheck,
  FileText,
  Building2,
  Server,
  Settings,
  Code,
  MapPin,
  Mail,
  Phone,
  MessageSquare,
  MousePointer,
  GitBranch,
  TrendingDown,
  TrendingUp,
  Brain,
  GraduationCap,
  Heart,
  Laptop,
  Rocket,
}

interface ConceptCardProps {
  title: string
  description: string
  href: string
  icon?: LucideIcon
  iconName?: string
  iconColor?: string
}

export function ConceptCard({
  title,
  description,
  href,
  icon: IconProp,
  iconName,
  iconColor = "text-primary"
}: ConceptCardProps) {
  const Icon = IconProp || (iconName ? iconMap[iconName] : undefined)

  return (
    <Link
      to={href}
      className="group relative block rounded-2xl border bg-card p-6 transition-all hover:shadow-lg hover:border-primary/50"
    >
      {Icon && (
        <div className={`inline-flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 ${iconColor}`}>
          <Icon className="h-6 w-6" />
        </div>
      )}

      <h3 className="mt-4 text-xl font-semibold group-hover:text-primary transition-colors">
        {title}
      </h3>

      <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
        {description}
      </p>

      <div className="mt-4 flex items-center text-sm font-medium text-primary opacity-0 group-hover:opacity-100 transition-opacity">
        Learn more
        <ArrowRight className="ml-1 h-4 w-4" />
      </div>
    </Link>
  )
}

interface ConceptCardGridProps {
  children: React.ReactNode
  columns?: 2 | 3 | 4
}

export function ConceptCardGrid({ children, columns = 3 }: ConceptCardGridProps) {
  const gridCols = {
    2: "sm:grid-cols-2",
    3: "sm:grid-cols-2 lg:grid-cols-3",
    4: "sm:grid-cols-2 lg:grid-cols-4"
  }[columns]

  return (
    <div className={`grid grid-cols-1 gap-6 ${gridCols}`}>
      {children}
    </div>
  )
}
